<template>
  <div>
    <div v-for="(item, index) in penerima_surat" :key="index">
      <div class="mb-5">
        <div v-if="form.kop_surat_url_image !== '' && form.kop_surat_url_image !== null"
            style="margin-bottom: 16px !important;">
            <v-img 
            contain
            width="100%"
            height="auto"
            alt="umb" 
            :src="form.kop_surat_url_image">
            <template v-slot:placeholder>
                <v-row
                class="fill-height"
                align="center"
                justify="center">
                <v-progress-circular 
                    indeterminate 
                    :color="set_color">
                </v-progress-circular>
                </v-row>
            </template>
            </v-img>
        </div>
  
        <div
          :style="form.kop_surat_url_image !== '' && form.kop_surat_url_image !== null ? 'padding: 0px 38px 0px 38px;' : 'padding: 38px;'">
  
          <v-card-text
            class="black--text py-2">
            <v-row>
              <v-col
                cols="12"
                md="7" style="padding-bottom: 0px;">
                <v-row>
                  <v-col
                    cols="12"
                    md="2"
                    class="py-0"
                    style="padding-top: 0px !important; padding-bottom: 0px !important;">
                    Nomor
                  </v-col>
  
                  <v-col
                    cols="12"
                    md="10"
                    class="py-0"
                    style="padding-top: 0px !important; padding-bottom: 0px !important;">
                    : {{ selected.preview.meta_json_object.nomor !== '' ? selected.preview.meta_json_object.nomor : '__________' }}
                  </v-col>
                </v-row>
              </v-col>
              <v-col
                cols="12"
                md="5"
                style="text-align: right !important; padding-bottom: 0px;">
                <div>
                  Yogyakarta, {{ selected.preview.meta_json_object.tanggal | fulldate }}
                </div>
              </v-col>
              <v-col
                cols="12"
                md="7" style="padding-top: 0px;">
  
                <v-row>
                  <v-col
                    cols="12"
                    md="2"
                    class="py-0"
                    style="padding-top: 0px !important; padding-bottom: 0px !important;">
                    Hal
                  </v-col>
  
                  <v-col
                    cols="12"
                    md="10"
                    class="py-0"
                    style="padding-top: 0px !important; padding-bottom: 0px !important;">
                    : <span style="font-weight: 700;">{{ selected.preview.meta_json_object.hal !== '' ? selected.preview.meta_json_object.hal : '__________' }}</span>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
  
            <v-row>
              <v-col
                cols="12"
                md="7">
              </v-col>
              <v-col
                cols="12"
                md="5">
                <div
                  class="mt-6"
                  style="margin-top: 24px !important;">
                  <div
                    style="margin-bottom: 1px;">
                    Kepada 
                  </div>
  
                  <div
                    style="margin-bottom: 1px;" >
                    Yth. 
                    <span>
                      {{ selected.preview.for !== '' ? selected.preview.for : '__________' }}
                    </span>
                  </div>
  
                  <div
                    style="margin-bottom: 1px;">
                    di Yogyakarta
                  </div>
                </div>
              </v-col>
            </v-row>
  
  
            <div
              class="mt-10"
              style="margin-top: 40px !important;">
              <div>
                <div class="ql-editor" v-html="selected.preview.meta_json_object.content"></div>
              </div>
            </div>
  
            <v-row
              justify="end"
              class="mt-8"
              style="display: flex; flex-wrap: wrap; flex: 1 1 auto; justify-content: flex-end !important; margin-top: 32px !important;">
              <v-col
                cols="12"
                md="6"
                class="text-center"
                style="text-align: center !important;">
  
                <div
                  >
                  {{ selected.preview.meta_json_object.jabatan_penandatangan !== '' ? selected.preview.meta_json_object.jabatan_penandatangan : '__________' }}
                </div>
  
                <div v-if="selected.preview.meta_json_object.image_ttd === ''" style="margin-bottom: 64px !important;">
  
                </div>
                <div v-else>
                  <v-img
                    contain
                    height="100"
                    width="100"
                    :src="selected.preview.meta_json_object.image_ttd" 
                    :alt="selected.preview.meta_json_object.image_ttd"
                    class="text-center d-flex align-center"
                    style="margin-left: auto; margin-right: auto; padding-top: 4px; padding-bottom: 4px;">
                  </v-img>
                </div>
  
                <div>
                  {{ selected.preview.meta_json_object.nama_penandatangan !== '' ? selected.preview.meta_json_object.nama_penandatangan : '__________' }}
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </div>
  
        <div v-if="form.kop_surat_url_image_footer !== '' && form.kop_surat_url_image_footer !== null"
            style="margin-top: 16px !important;">
            <v-img 
            style="position: absolute; bottom: 0;"
            contain
            width="100%"
            height="auto"
            alt="umb" 
            :src="form.kop_surat_url_image_footer">
            <template v-slot:placeholder>
                <v-row
                class="fill-height"
                align="center"
                justify="center">
                <v-progress-circular 
                    indeterminate 
                    :color="set_color">
                </v-progress-circular>
                </v-row>
            </template>
            </v-img>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { get, post, put, destroy } from "@/service/Axios";
  import { TokenService } from "@/service/Storage.Service";
  import axios from "axios";
  import moment from "moment"
  import "moment/locale/id"
  import html2pdf from 'html2pdf.js'
  export default {
    props: {
      form: {
        type: Object,
        default: {}
      },
      selected: {
        type: Object,
        default: {}
      },
      anggota: {
        type: Array,
        default: []
      },
      process: {
        type: Object,
        default: {}
      },
      penerima_surat: {
        type: Array,
        default: []
      }
    },
    data () {
      return {
        picker: {
          expired: false,
          tanggal: false,
          tanggal_mulai: false,
          tanggal_selesai: false,
          tanggal_masuk: false,

          range: false
        },

        time: {
          pukul: false
        },
      }
    },
    components: {
      
    },
    watch: {

    },
    computed: {
      user () {
        return this.$store.state.user
      },
      
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb_soft () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.2)`
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.2)`
      },

      configHeaders () {
        return this.headers.filter(header => !header.hide)  
      },

      // formattedDate: {
      //   get () {
      //     return (this.form.template_meta_json_object.tanggal && this.form.template_meta_json_object.tanggal.length === 10) ? moment(this.form.template_meta_json_object.tanggal).format('DD MMMM YYYY') : this.form.template_meta_json_object.tanggal
      //   },
      //   set (newValue) {
      //     if (newValue && newValue.length == 10) {
      //         let newDate = `${newValue.substring(6, 10)}-${newValue.substring(3, 5)}-${newValue.substring(0, 2)}`
      //         this.form.template_meta_json_object.tanggal = newDate
      //     }
      //   }
      // },

      date_range () {
        return this.filter.dates.join(' s/d ')
      }
    },
    mounted () {
      
    },
    methods: {

    }
  }
</script>